import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "./assets/css/MarkerCluster.css";
import "./assets/css/MarkerCluster.Default.css";
import axios from "axios";
import moment from 'jalali-moment'
import VueSkycons from "vue-skycon";
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import VueSimpleAlert from "vue-simple-alert";
import Notifications from 'vue-notification'
import VueHtmlToPaper from "vue-html-to-paper";
const VueHtmlToPaperOptions = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    '/assets/css/report-style.css',
    '/assets/css/bootstrap.rtl.min.css',
 
  ]
}
Vue.component('date-picker', VuePersianDatetimePicker);
String.prototype.formatPersianDate = function (inputFormat = 'YYYY/M/D', outputFormat = 'jYYYY/jMM/jDD') {
  try {
    let m = moment(this, inputFormat);
    return m.locale('fa').format(outputFormat)
  } catch (e) {
    return this;
  }
}

String.prototype.formatPrice = function () {
  if (window.locale == "fa") {
    return parseInt(this).toLocaleString().toPersianDigits();
  }
  return parseInt(this).toLocaleString();
};
String.prototype.toPersianDigits = function () {
  var id = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return this.replace(/[0-9]/g, function (w) {
    return id[+w];
  });
};

Vue.config.productionTip = false

Vue.prototype.$https = axios.create({
  baseURL: '//iran-safar.com'
})
Vue.use(vSelect)
Vue.use(VueSkycons)
Vue.use(VueSimpleAlert);
Vue.use(Notifications)
Vue.use(VueHtmlToPaper,VueHtmlToPaperOptions);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


